const sectionSelector = '.featured-investments-section';

let swiperDepsPromise = null;

function getSwiperDeps() {
	if (!swiperDepsPromise) {
		swiperDepsPromise = Promise.all([
			import('swiper'),
			import('swiper/modules'),
		]).then(([swiperModule, modules]) => ({
			Swiper: swiperModule.Swiper,
			Autoplay: modules.Autoplay,
		}));
	}

	return swiperDepsPromise;
}

const sectionCallBack = async (sectionElement, q) => {
	const sliderEl = q('.swiper');
	if (!sliderEl) return;
	if (sliderEl.swiperInstance) return;

	let Swiper;
	let Autoplay;

	try {
		({ Swiper, Autoplay } = await getSwiperDeps());
	} catch {
		return;
	}

	const swiper = new Swiper(sliderEl, {
		modules: [Autoplay],
		slidesPerView: 'auto',
		loop: true,
		speed: 6000,
		pixelSnap: true,
		spaceBetween: 20,
		breakpoints: {
			400:  { slidesPerView: 3, spaceBetween: 20 },
			600:  { slidesPerView: 4, spaceBetween: 25 },
			900:  { slidesPerView: 5, spaceBetween: 25 },
			1200: { slidesPerView: 6, spaceBetween: 30 },
			1500: { slidesPerView: 7, spaceBetween: 35 },
			1920: { slidesPerView: 8, spaceBetween: 40 }
		},
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
			pauseOnMouseEnter: false,
		},
		on: {
			// Ensure linear easing for smooth continuous scroll
			init() {
				this.wrapperEl.style.transitionTimingFunction = 'linear';
			},
		},
	});

	sliderEl.swiperInstance = swiper;
};

export { sectionSelector, sectionCallBack };
